import { HttpClient } from '@angular/common/http';
import { ResponseObject } from '@app/shared/models/response-object';
import { environment } from '@env/environment';
import { Observable, catchError, map, retry } from 'rxjs';
import { GroupList } from './api.group-management.model';

export class GroupManagementApi {
  apiUrl = environment.API_URL;
  constructor(public readonly http: HttpClient) {}

  getGroups(
    pageNum: number,
    pageSize: number,
    keySearch?: string,
    parameter?: any
  ): Observable<GroupList> {
    let url = `${this.apiUrl}/group/management/search?pageNum=${pageNum}&pageSize=${pageSize}`;
    if (keySearch) {
      url += `&textSearch=${keySearch}`;
    }
    if (parameter && parameter.selectedStatuses && parameter.selectedStatuses.length) {
      const parsedString = parameter.selectedStatuses?.join('|');
      const encodedStatusString = encodeURIComponent(parsedString);
      url = url + `&status=${encodedStatusString}`;
    };
    if (
      parameter &&
      parameter.selectedPrivacyOrCategory &&
      parameter.selectedPrivacyOrCategory.length < 2
    ) {
      url = url + `&privacy=${parameter.selectedPrivacyOrCategory}`
    }
    return this.http.get<ResponseObject>(url).pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getSummaryInfoGroup(): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.apiUrl}/group/management`).pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  putActionGroup(groupId: string, body: any): Observable<ResponseObject> {
    return this.http
      .put<ResponseObject>(`${this.apiUrl}/group/management/${groupId}/status`, body)
      .pipe(
        retry(1),
        map((res: any) => {
          return res.data;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
